import moment from 'moment'

export const convertDateTime = (time, format) => {
    // return moment(time).utcOffset(0).format(format);
    return moment(time).format(format);
};